import React, { useState, useEffect } from 'react';
import { Container, Table } from 'react-bootstrap';
import { listDocumentoEstadoContableSitioWeb } from '@/api/municipalidadAPI';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { URL_ADJUNTOS } from '../constants/constants';
import './EstadosContablesView.css';

const EstadosContablesView = () => {
  const [estados, setEstados] = useState(null);

  const tipoEstadoContable = [
    { value: 'RECURSOS', label: 'Ejecución de Recursos' },
    { value: 'GASTOS', label: 'Ejecución de Gastos' },
  ];

  const getTipoEstadoContable = (valor) => {
    return tipoEstadoContable.filter((i) => i.value == valor)[0].label;
  };

  useEffect(() => {
    listDocumentoEstadoContableSitioWeb()
      .then((response) => {
        setEstados(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Estados Contables"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <h7 className="estados-title">
          Puede descargar los Estados Contables en los siguientes enlaces.
        </h7>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Subido por</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            {estados !== null &&
              estados.length > 0 &&
              estados.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={URL_ADJUNTOS + '?id=' + item.documento.id}
                    >
                      {getTipoEstadoContable(item.tipoEstadoContable)}{' '}
                      {item.mesAsString + ' ' + item.anioDocumentoAsString}
                    </a>
                  </td>
                  <td>{item.usuarioCreacion}</td>
                  <td>{item.fechaCreacion}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export default React.memo(EstadosContablesView);
